import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { connect } from 'react-redux';
import { withQuery } from 'react-apollo';
import Spin from 'components/common/Spin';
import { GET_STUDENTS_GUARDIANS } from 'graphql/guardian';
import Navigation from 'modules/parent/components/navigation';
import StudentRoutes from '../modules/parent/StudentRoutes';
import studentsList from '../modules/parent/studentsList';
import Profile from '../modules/parent/profile';
import Meeting from './twilio/VideoChat';
import Purchase from '../modules/parent/purchase';
import MeetingView from '../modules/admin/meeting/view';
import WelcomeVideo from '../modules/parent/components/video';
import Chat from '../modules/parent/chat/inbox';
import Layout from './Layout';
import {
  ParentSidebar,
  SoloParentSidebar,
  CohortParentSidebar,
} from 'constant';
import Referral from '../modules/referral';
import client from '../graphql/client';
import { GET_PARENT_STUDENT } from '../graphql/student/Profile';
import SharePopup from "./social-share/SharePopup";

const cookies = new Cookies();

class Parent extends React.Component {
  state = { showVideo: false, sidebar: ParentSidebar };

  componentDidMount() {
    const show = cookies.get('welcome_video');
    if (!show) {
      this.setState({ showVideo: true });
      cookies.set('welcome_video', '1', {
        path: '/',
        expires: new Date(2099, 1, 1),
      });
    }
    client
      .query({
        query: GET_PARENT_STUDENT,
        variables: {
          userId: this.props.user.id,
        },
      })
      .then(({ data }) => {
        if (data.rows[0].student_profile.product_type === 'solo') {
          this.setState({ sidebar: SoloParentSidebar, solo: true });
        } else if (data.rows[0].student_profile.product_type === 'cohort') {
          this.setState({ sidebar: CohortParentSidebar, solo: true });
        }
      });
  }

  render() {
    const { data } = this.props;
    const { showVideo } = this.state;
    const { student_guardians, loading, error } = data;
    if (loading) return <Spin spinning linear />;
    if (error) return error.message;

    const [studentGuardian] = student_guardians;

    if (!studentGuardian) return 'No student assigned to the guardian';

    return (
      <Layout
        navigations={this.state.sidebar}
        role="parent"
        product="solo"
        renderHeader={({ toggleMenu }) => (
          <Navigation toggleMenu={toggleMenu} />
        )}
      >
        <>
          <SharePopup />
          <Switch>
            <Route
              path="/profile"
              render={(props) => <Profile {...props} sub={this.props.sub} />}
            />
            <Route path="/inbox/:studentId?/:roomId?" component={Chat} />
            <Route path="/purchase" component={Purchase} />
            <Route exact path="/students" component={studentsList} />
            <Route path="/students/:id/:product?" component={StudentRoutes} />
            <Route exact path={'/meeting/:roomId'} component={Meeting} />
            <Route
              exact
              path={'/meeting/:conferenceId/view'}
              component={MeetingView}
            />
            <Route
              exact
              path={'/meeting/group/:roomId'}
              component={(props) => <Meeting {...props} isGroup />}
            />
            <Route
              path="/referral"
              render={() => <Referral solo={this.state.solo} />}
            />
            <Redirect from="/" to="/students" />
          </Switch>
          {showVideo && (
            <WelcomeVideo onClose={() => this.setState({ showVideo: false })} />
          )}
        </>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user.user,
});

export default connect(mapStateToProps)(
  withQuery(GET_STUDENTS_GUARDIANS)(Parent),
);
